import { render, staticRenderFns } from "./ModalListStatus.vue?vue&type=template&id=620a0db5&lang=pug&"
import script from "./ModalListStatus.vue?vue&type=script&lang=js&"
export * from "./ModalListStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports